import { SizeUpdater } from "./SizeUpdater.js";
export async function loadSizeUpdater(engine, refresh = true) {
    await engine.addParticleUpdater("size", () => new SizeUpdater(), refresh);
}
